/**
 * Shared constants for AI Arena variant naming and descriptors.
 */

/** AI type labels per model — describes the algorithm/strategy */
export const MODEL_TYPE_LABELS: Record<string, string> = {
  gaia: 'Heuristic-MCTS',
  sentinel: 'Minimax',
  alchemist: 'MCTS',
  zenith: 'Hybrid',
  hunter: 'Minimax-capture',
  wisp: 'Race-MCTS',
  creature: 'Priority-Minimax',
  arrow: 'Minimax-race',
};

/** Speed labels per time frame */
export const SPEED_LABELS: Record<string, string> = {
  fast: 'Fast',
  standard: 'Standard',
  deep: 'Deep',
};

/** Display names for variant IDs (e.g. "sentinel-fast" → "Drone") */
export const NAMED_VARIANTS: Record<string, string> = {
  'gaia-fast': 'Flora',
  'gaia-standard': 'Prima',
  'gaia-deep': 'Gaia',
  'sentinel-fast': 'Drone',
  'sentinel-standard': 'Sentinel',
  'sentinel-deep': 'Mainframe',
  'alchemist-fast': 'Jester',
  'alchemist-standard': 'Alchemist',
  'alchemist-deep': 'Oracle',
  'zenith-fast': 'Nadir',
  'zenith-standard': 'Nexus',
  'zenith-deep': 'Zenith',
  'hunter-fast': 'Seeker',
  'hunter-standard': 'Hunter',
  'hunter-deep': 'Stalker',
  'wisp-fast': 'Ember',
  'wisp-standard': 'Poe',
  'wisp-deep': 'Wisp',
  'creature-fast': 'Creature',
  'creature-standard': 'Golem',
  'creature-deep': 'Eidolon',
  'arrow-fast': 'Bullet',
  'arrow-standard': 'Arrow',
  'arrow-deep': 'Rocket',
};

/** Resolve a variant ID like "sentinel-standard" to a descriptor like "Minimax - Standard" */
export function resolveVariantDescriptor(variantId: string): string {
  const parts = variantId.split('-');
  const model = parts[0];
  const speed = parts[1];
  const typeLabel = MODEL_TYPE_LABELS[model];
  const speedLabel = SPEED_LABELS[speed];
  if (!typeLabel || !speedLabel) return variantId;
  return `${typeLabel} - ${speedLabel}`;
}

/** Check if a player ID looks like an AI arena variant (e.g. "sentinel-fast") */
export function isArenaVariantId(id: string): boolean {
  return id in NAMED_VARIANTS;
}
